module.exports = __webpack_public_path__ + "static/adhoc-software-185a87bf14230137ab58e2f19844fd67.jpg";